import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Toolbar, useMediaQuery } from '@mui/material';

// project import
import Drawer from './Drawer';
import Header from './Header';
import navigation from 'menu-items';
import Breadcrumbs from 'components/@extended/Breadcrumbs';
import TCPopup from 'components/user/TCPopup';

// types
import { openDrawer } from 'store/reducers/menu';
import { selectCurrentUser } from 'store/user/user.selector';

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
    // window.onbeforeunload = () => {
    //     if (localStorage.getItem('rememberMe') == 'false'){
    //       localStorage.removeItem('token');
    //       localStorage.removeItem('apiKey');
    //     }
    // }
    
    const theme = useTheme();
    const matchDownLG = useMediaQuery(theme.breakpoints.down('xl'));
    const dispatch = useDispatch();
    const location = useLocation();

    const { drawerOpen } = useSelector((state) => state.menu);
    const user = useSelector(selectCurrentUser);

    // drawer toggler
    const [open, setOpen] = useState(drawerOpen);
    const handleDrawerToggle = () => {
        setOpen(!open);
        dispatch(openDrawer({ drawerOpen: !open }));
    };

    // set media wise responsive drawer
    useEffect(() => {
        setOpen(!matchDownLG);
        dispatch(openDrawer({ drawerOpen: !matchDownLG }));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [matchDownLG]);

    useEffect(() => {
        if (open !== drawerOpen) setOpen(drawerOpen);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [drawerOpen]);

    useEffect(() => {
        // Check if user exists, hasn't accepted T&C, and isn't currently on the terms page
        if (user && user.PromptTC && location.pathname !== '/terms') {
            window.dispatchEvent(new CustomEvent('show-tc-popup', {"detail": user}));
        }
    }, [user, location.pathname]); // Re-run if user data or location changes

    return (
        <Box sx={{ display: 'flex', width: '100%' }}>
            <Header open={open} handleDrawerToggle={handleDrawerToggle} />
            <Drawer open={open} handleDrawerToggle={handleDrawerToggle} />
            <Box component="main" sx={{ width: '100%', flexGrow: 1, p: { xs: 2, sm: 3 } }}>
                <Toolbar />
                <Breadcrumbs navigation={navigation} title titleBottom card={false} divider={false} />
                <Outlet />
            </Box>
            <TCPopup />
        </Box>
    );
};

export default MainLayout;
